import { MetaDefinition } from '@angular/platform-browser';

export const ROBOTS_NO_INDEX: MetaDefinition = {
  name: 'robots',
  content: 'noindex'
};
